const createDateRange = (value: [Date?, Date?]) => {
    const [gte, lt] = value.map((date, idx) => {
        if (!date) {
            return undefined;
        }

        const newDate = new Date(date);

        if (idx === 1) {
            newDate.setDate(newDate.getDate() + 1);
        }

        return newDate.toISOString();
    });

    return {
        gte,
        lt,
    };
};

export const getWhereVariables = (querySearch?: { searchString?: string }, dateValue?: [Date?, Date?] | null) => {
    const searchString = querySearch?.searchString;
    const isSearch = !!searchString && searchString?.length > 0;
    const updatedDateValue = createDateRange(dateValue || []);
    const hasDate = dateValue?.length && dateValue?.length > 0;

    const stringWhere = isSearch
        ? {
              or: [
                  {
                      entityDisplayName: {
                          containsi: searchString,
                      },
                  },
              ],
          }
        : undefined;

    if (hasDate && !isSearch) {
        return {
            and: [{ date: updatedDateValue }],
        };
    }

    if (stringWhere && hasDate) {
        return {
            and: [stringWhere, { and: [{ date: updatedDateValue }] }],
        };
    }

    return stringWhere || undefined;
};
